export const RSVP_YES = 'rsvp-yes';
export const RSVP_NO = 'rsvp-no';
export const RSVP_UPDATE = 'rsvp-update';
export const RSVP_WAITLIST = 'rsvp-waitlist';
export const DOUBLE_OPT_IN = 'double-opt-in';
export const TICKET_DEFAULT = 'ticket-default';
export const TICKET_MULTI = 'ticket-multi';
export const TICKET_CUSTOM = 'ticket-custom';

// Used for creating new custom ticket confirmations
export const NEW_CONFIRMATION = '__new';
